const styleMap = {
  oracle: {
    title: "Astral Oracle",
    tint: "from-amber-200 via-amber-400 to-orange-500",
    halo: "bg-amber-300/20",
  },
  keeper: {
    title: "Temple Keeper",
    tint: "from-slate-100 via-[#D4AF37] to-slate-500",
    halo: "bg-[#D4AF37]/20",
  },
  mirror: {
    title: "Living Mirror",
    tint: "from-cyan-100 via-sky-300 to-indigo-500",
    halo: "bg-sky-400/20",
  },
};

export const VipOrbAvatar = ({ styleKey = "keeper", name = "Kōnshus", posterSrc, videoSrc }) => {
  const current = styleMap[styleKey] || styleMap.keeper;

  return (
    <div className="relative mx-auto flex h-72 w-72 items-center justify-center" data-testid="vip-orb-avatar">
      <div className={`absolute inset-8 rounded-full blur-3xl ${current.halo}`} />
      <div className="absolute inset-0 rounded-full border border-primary/10 [animation:spin_32s_linear_infinite]" />
      <div className="absolute inset-3 rounded-full border border-white/10 [animation:spin_20s_linear_infinite]" />
      <div className="absolute inset-10 rounded-full border border-primary/20 [animation:spin_14s_linear_infinite_reverse]" />
      <div className={`float-slow relative flex h-44 w-44 items-center justify-center overflow-hidden rounded-full bg-gradient-to-br ${current.tint} shadow-[0_0_60px_rgba(212,175,55,0.22)]`}>
        {videoSrc ? (
          <video autoPlay className="absolute inset-0 h-full w-full object-cover" loop muted playsInline poster={posterSrc}>
            <source src={videoSrc} type="video/mp4" />
          </video>
        ) : null}
        <div className="absolute inset-0 bg-black/20" />
        <div className="absolute inset-5 rounded-full border border-white/30" />
        <div className="absolute inset-10 rounded-full border border-black/10" />
        <div className="absolute right-12 top-10 h-8 w-8 rounded-full bg-white/70 blur-sm" />
      </div>
      <p className="absolute bottom-0 text-xs uppercase tracking-[0.32em] text-primary/80" data-testid="vip-orb-title">
        {name}
      </p>
    </div>
  );
};